import { commonMetas } from '@components/common/constant';
import Metacategories from '@components/common/metaJson/category.json';
import { isLowerEnv, isProdEnv } from 'helper';

export const RemoteCategoriesMetaTags = (props: any) => {
  // Collect all the generated meta tags
  const allMetaTags = Metacategories.flatMap((obj: any) => {
    // Get the first (and only) key of each object
    const key =
      Object.keys(obj).find((item) => item == props.categoryName) || '';
    // Access the nested object using that key and create meta tags
    return key && createMetaTags({ ...commonMetas[0], ...obj[key] }, props);
  });
  const index = allMetaTags.findIndex((m) => m.key == 'robots');
  if (index == -1) {
    allMetaTags.push(
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />
    );
  }
  if (props.isQueryParamsEmpty != undefined && !props.isQueryParamsEmpty) {
    //remove robots meta tag from the allMetaTags that has index and follow then add no follow and index
    if (index > -1) allMetaTags.splice(index, 1);
    allMetaTags.push(<meta name="robots" content="noindex, nofollow" />);
  }
  // Return the meta tags as JSX elements
  return <>{allMetaTags}</>;
};

function createMetaTags(data: { [key: string]: any }, props: any): any[] {
  const metaTags: any[] = [];
  // Loop over the properties of the data object
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      if (key === 'preconnect') {
        data[key].map((item: any) => {
          metaTags.push(
            <link rel="preconnect" href={item} crossOrigin="anonymous" />
          );
        });
      } else if (key === 'canonical' && !props.canonicalTwo && isProdEnv) {
        metaTags.push(<link rel="canonical" href={data[key]} />);
      } else if (key === 'canonicalTwo' && props.canonicalTwo && isProdEnv) {
        metaTags.push(<link rel="canonical" href={data['canonicalTwo']} />);
      } else if (key === 'title') {
        metaTags.push(<title key="title">{data[key]}</title>);
        /***remote-jobs all pages are affected. So this meta tag remove 
        metaTags.push(<meta name={key} content={String(data[key])} />);**/
      } else if (key === 'yoast-schema') {
        // Create script tag for yoast-schema
        metaTags.push(
          <script
            type="application/ld+json"
            className="yoast-schema-graph"
            key="yoast-schema"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data[key]) }}
          />
        );
      } else if (typeof data[key] === 'object' && data[key] !== null) {
        // Recursively handle nested objects
        for (const nestedKey in data[key]) {
          if (Object.prototype.hasOwnProperty.call(data[key], nestedKey)) {
            metaTags.push(
              <meta
                name={`${key}:${nestedKey}`}
                content={String(data[key][nestedKey])}
                key={`${key}:${nestedKey}`}
              />
            );
          }
        }
      } else if (
        ![
          'canonicalTwo',
          'canonical',
          ...(isLowerEnv ? ['robots'] : []),
        ].includes(key)
      ) {
        // Create meta tag for non-object properties
        metaTags.push(
          <meta name={key} content={String(data[key])} key={key} />
        );
      }
    }
  }
  return metaTags;
}
